/**
 * Use when normalizing e.g. learner email, username or password.
 *
 * This normalizes unicode input using NFKC.
 * NFKC converts characters that have different visual variants into their standard forms. This means a full-width character becomes a half-width.
 *
 * Technically this would also normalize other characters (e.g. ligatures) but we only care about the full->half width normalization.
 * Composition vs decomposition is also irrelevant to us. NFK_C_ is more conservative so picked that.
 */

export const normalizeLearnerCredential = (value: string) => {
  return value.normalize("NFKC").replace(/\s/g, "");
};

const MIN_LEARNER_PASSWORD_LENGTH = 8;
const LEARNER_PASSWORD_REGEX = /^[!-~]+$/;

export type LearnerPasswordValidationErrorCode = "tooShort" | "invalidString";

export const validateLearnerPassword = (
  input: string,
): LearnerPasswordValidationErrorCode | undefined => {
  if (input.length < MIN_LEARNER_PASSWORD_LENGTH) return "tooShort";

  if (!LEARNER_PASSWORD_REGEX.test(input)) return "invalidString";
};
